import { Form, Formik } from 'formik';
import * as bd from 'react-basic-design';
import { CountryDTO } from '../../../api/country-api';
import SvgClose from '../../../assets/icons/Close';
import SvgDelete from '../../../assets/icons/Delete';
import SvgSave from '../../../assets/icons/Save';
import { BasicModal } from '../../../components/basic/basic-modal';
import { T } from '../../../components/basic/text';
import { yup } from '../../../components/basic/yup';
import { FormikTextField } from '../../../components/formik';

interface SaveCountryModalProps {
    show: boolean;
    allowEdit: boolean;
    selectedCountry?: CountryDTO;
    onHide: () => void;
    onSave: (values: CountryDTO) => void;
    onDelete?: (country: CountryDTO) => void;
}

export function SaveCountryModal({
    show,
    allowEdit,
    selectedCountry,
    onHide,
    onSave,
    onDelete,
}: SaveCountryModalProps) {
    const CountrySchema = yup.object().shape({
        id: yup.string().required(' '),
        name: yup.string().required(' '),
    });

    const defaultValues: CountryDTO = {
        id: selectedCountry ? selectedCountry.id : '',
        name: selectedCountry ? selectedCountry.name : '',
    };

    if (!show) return <></>;

    return (
        <Formik initialValues={defaultValues} validationSchema={CountrySchema} onSubmit={onSave}>
            {formik => (
                <BasicModal
                    show={show}
                    onHide={onHide}
                    title={
                        <bd.Flex className="w-100" align="center" content="between">
                            <T>{selectedCountry ? 'edit-country' : 'new-country'}</T>
                            <bd.Flex align="center" gap={2}>
                                <bd.Button
                                    variant="icon"
                                    size="sm"
                                    onClick={formik.submitForm}
                                    disabled={!allowEdit}
                                >
                                    <SvgSave />
                                </bd.Button>
                                {selectedCountry && onDelete && (
                                    <bd.Button
                                        disabled={!allowEdit}
                                        variant="icon"
                                        color="secondary"
                                        size="sm"
                                        onClick={() => onDelete(selectedCountry)}
                                    >
                                        <SvgDelete />
                                    </bd.Button>
                                )}
                                <bd.Button
                                    variant="icon"
                                    color="secondary"
                                    size="sm"
                                    onClick={onHide}
                                >
                                    <SvgClose />
                                </bd.Button>
                            </bd.Flex>
                        </bd.Flex>
                    }
                >
                    <Form>
                        <bd.Flex align="center" wrap>
                            <FormikTextField
                                label="id"
                                name="id"
                                readOnly={!allowEdit || !!selectedCountry}
                                width="11rem"
                                handleEnter
                            />

                            <FormikTextField
                                label="name"
                                name="name"
                                readOnly={!allowEdit}
                                width="11rem"
                                handleEnter
                            />
                        </bd.Flex>
                    </Form>
                </BasicModal>
            )}
        </Formik>
    );
}
